import AdditionalEmailConfirmation from './AdditionalEmailConfirmation'
import GlobalDataset from './GlobalDataset'
import Google from './Google'
import Hotjar from './Hotjar'
import SessionStart from './SessionStart'

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const Middlewares = ({ children }: Props) => (
  <GlobalDataset>
    <SessionStart>
      <AdditionalEmailConfirmation>
        <Google>
          <Hotjar>{children}</Hotjar>
        </Google>
      </AdditionalEmailConfirmation>
    </SessionStart>
  </GlobalDataset>
)

export default Middlewares
